import { MDBCol, MDBRow } from "mdb-react-ui-kit";

import { faGlobe, faHome, faLocation, faLocationDot, faPhone, faShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import contact from "../asset/images/BGImages/contact.jpg";

export default function Footer(props) {
    return (
        <div
            className="w-100"
            id="about"
            style={{
                height: "50%",
                backgroundColor: "#fff",
                borderTop: "0px solid white"
            }}
        >
            {/* <h2 className=" display-5 fw-bold text-center text-light w-100 mb-4">About Us</h2> */}
            <MDBRow className="h-100 mx-0" id="lRow">
                <MDBCol md="6" className="h-100 px-2 py-3 d-flex justify-content-center align-items-center" id="lCol">
                    <img src={contact} alt="contact us" className="rounded-5" style={{ height: "80%", width: "80%", objectFit: "cover" }} />
                </MDBCol>
                <MDBCol md="6" className="h-100 px-3 py-2 d-flex flex-column justify-content-center align-items-center" id="lCol">
                    <h2 className=" display-5 fw-bold text-start theme-color w-100 mb-4">Get In Touch</h2>
                    <p className="fw-bold text-start w-100 px-2">
                        <FontAwesomeIcon icon={faHome} className="me-2 theme-color" />
                        werfenfin.in</p>
                    <p className="fw-bold text-start w-100 px-2">
                        <FontAwesomeIcon icon={faLocationDot} className="me-2 theme-color" />
                        Hosur, Tamilnadu 635109</p>
                    <p className="fw-bold text-start w-100 px-2">
                        <FontAwesomeIcon icon={faPhone} className="me-2 theme-color" />
                        +91-9566033134</p>
                    <p className="fw-bold text-start w-100 px-2">
                        <FontAwesomeIcon icon={faGlobe} className="me-2 theme-color" />
                        info@werfenfin.in</p>
                    <p className="fw-bold text-start w-100 px-2">
                        <FontAwesomeIcon icon={faShield} className="me-2 theme-color" />
                        Legal Notice | Privacy Policy</p>
                </MDBCol>
            </MDBRow>

        </div>
    )
}